import React from 'react';
import { AuthContextProps, useAuth } from 'oidc-react';
import { ItemSize } from '../utils/FileDownload';
import LocalDatabase from '../database/LocalDatabase';
import BufferedTransmitter from '../controller/BufferedTransmitter';
import SnapshotsController from '../controller/SnapshotsController';
import Authenticator from './Authenticator';
import { LoginLoop } from './LoginLoop';


/**
 * Wrap the LoginLoop in a layer that initializes the Authenticator 
 * with the authentication context that the oidc library provides.
 */
export function AuthWrapper(props: {
  itemSize: ItemSize, 
  localDatabase: LocalDatabase, 
  bufferedTransmitter: BufferedTransmitter, 
  snapshotsController: SnapshotsController, 
  serverLoginUrl: string,
  authenticator: Authenticator
}) : JSX.Element 
{
  const auth : AuthContextProps = useAuth();
  props.authenticator.configure(auth);
  // Push the access token to telemetry.js whenever the auth state changes
  // (login, silent renew) so the telemetry service can populate userId /
  // schoolIdentifier / studyId / federalState from the JWT claims. Best-effort.
  try {
    const tel: any = (window as any).aleaTelemetry;
    if (tel && typeof tel.setAuthToken === 'function' && props.authenticator.isAuthenticated()) {
      tel.setAuthToken(props.authenticator.getAuthenticationTokenServerString());
    }
  } catch { /* telemetry is best-effort */ }
  return (
    <LoginLoop 
      itemSize={props.itemSize} 
      localDatabase={props.localDatabase} 
      bufferedTransmitter={props.bufferedTransmitter} 
      snapshotsController={props.snapshotsController} 
      serverLoginUrl={props.serverLoginUrl} 
      auth= {auth}
      signOut= {() => props.authenticator.logout()} 
    />
  )
}
